<template>
    <!-- 空的 Template -->
    <router-view/>
</template>


<script>
    export default {
        name: 'EmptyView'
    }
</script>
